import { environment } from './../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private defaultLanguage = 'en';

  constructor(private translate: TranslateService) {
  }

  public init(): void {
    //first language will be default language
    const supportedLanguages = environment.supportedLanguages?.split(',').filter(s => s?.length > 0) ?? ['en'];
    this.translate.addLangs(supportedLanguages);
    // this language will be used as a fallback when a translation isn't found in the current language
    this.defaultLanguage = supportedLanguages[0];
    this.translate.setFallbackLang(supportedLanguages[0]);
  }

  public getLanguages(): readonly string[] {
    return this.translate.getLangs();
  }

  public getDefaultLanguage(): string {
    return this.defaultLanguage;
  }
}
